import { StateSchema } from './StoreProvider.types';

export const initialState: Partial<StateSchema> = {};
